module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-32.39b13098.png";